import { toast } from "react-toastify";
import { createSlice } from '@reduxjs/toolkit';
import PaymentService from "../../services/PaymentService";

interface APIResponse {
    data: {
        status: number,
        message: string,
        data?: any
    }
}

const Payment = createSlice({
    name: 'payment',
    initialState: {
        paymentList: {},
    },
    reducers: {
        paymentList: (state, action) => {
            state.paymentList = action.payload
        }
    }
})

export default Payment.reducer;

const { paymentList } = Payment.actions


/**
 * Function to make API call to fetch payment listing
 * @param params 
 * @returns 
 */
export const getPaymentList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        
        PaymentService.getPaymentListing(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                        dispatch(paymentList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}






